const header = document.querySelector('.header');
const hadScrollClassOnLoad = header.classList.contains('header--scroll');
var body = document.body;


if (!hadScrollClassOnLoad) {
    window.addEventListener('scroll', function () {
        if (window.scrollY > 0) {
            header.classList.add('header--scroll');
            body.classList.add("body--scroll");
        } else {
            header.classList.remove('header--scroll');
            body.classList.remove("body--scroll");
        }
    });
}